module.exports = __webpack_public_path__ + "static/img/solutionText11.5647192.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionText11.png
// module id = C1Dp
// module chunks = 1